// extracted by mini-css-extract-plugin
module.exports = {"flexModel":"modal-overlay_flexModel__2VMG7","modalActive":"modal-overlay_modalActive__3Y1TS modal-overlay_flexModel__2VMG7"};